import { cva } from 'class-variance-authority';

export const optionWrapperStyles = cva('group', {
  variants: {
    intent: {
      default: ['flex items-center justify-between pr-[10px] pl-2 py-[10px] hover:bg-blue-50 cursor-pointer'],
      old: ['flex items-center justify-between pr-[10px] p-[6px] hover:bg-[#5897fb] cursor-pointer h-[36px]'],
    },
    isSelected: {
      true: [],
      false: [],
    },
  },
  compoundVariants: [
    {
      intent: 'default',
      isSelected: true,
      className: 'bg-blue-50',
    },
    {
      intent: 'old',
      isSelected: true,
      className: 'bg-[#5897fb]',
    },
  ],
});

export const imageStyles = cva('w-[32px] h-[32px] rounded-full object-cover');

export const optionLabelStyles = cva([], {
  variants: {
    intent: {
      default: ['text-body-responsive', 'text-grey-700'],
      old: ['font-canela text-[#212529] text-base leading-[1.5]'],
    },
  },
  defaultVariants: {
    intent: 'default',
  },
});

export const iconStyles = cva('rotate-270 w-4 h-4', {
  variants: {
    intent: {
      default: ['rotate-270 transition-transform duration-200'],
      old: ['hidden'],
    },
    defaultVariants: {
      intent: 'default',
    },
  },
});

export const checkIconStyles = cva('w-4 h-4', {
  variants: {
    intent: {
      default: ['w-4 h-4'],
      old: ['hidden'],
    },
  },
});
